import { render, staticRenderFns } from "./simpleUploader.vue?vue&type=template&id=12f4ebce&"
import script from "./simpleUploader.vue?vue&type=script&lang=js&"
export * from "./simpleUploader.vue?vue&type=script&lang=js&"
import style0 from "./simpleUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports